import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

import { cn } from "../../lib/cn";

type Props = {
  to: string;
  /** Names the destination, e.g. "Back to the session list". */
  label: string;
  className?: string;
};

/** The round back control that opens a page's title band, as on the eval dashboard. */
export default function BackLink({ to, label, className }: Props) {
  return (
    <Link
      to={to}
      aria-label={label}
      title={label}
      className={cn(
        "control grid h-10 w-10 shrink-0 place-items-center rounded-pill text-ink hover:text-ink-3",
        className,
      )}
    >
      <ArrowLeft size={18} strokeWidth={1.4} aria-hidden />
    </Link>
  );
}
